<div class="row row-header">
  <div class="col-md-11 col-sm-11">
    <h1 mat-dialog-title class="text-center ml100">{{Heading}}</h1>
  </div>
  <div class="col-md-1 col-sm-1 nopadding">
    <a class="cancelBtn cancelBtnPos" (click)="onCancelClick()">cancel</a>
  </div>
</div>

<div class="FormContainer pt-20">
  <form #workspaceFormContainer="ngForm">
    <div mat-dialog-content>
      <div class="row px-5 pt-2 no-overflow">
        <div class="col-sm-6 division pad-lr">
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Location</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required
                     name="locationName"
                     ngModel #locationName="ngModel"
                     [(ngModel)]="workspaceData.locationName"
                     [typeahead]="locationList"
                     [typeaheadOptionField]="'locationName'"
                     placeholder="Enter Location"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(locationName.invalid && locationName.touched)">
                Please provide valid location
              </span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Storage Account</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required
                     name="StorageAccount"
                     ngModel #storageAccount="ngModel"
                     [(ngModel)]="workspaceData.storAcctName"
                     [typeahead]="storageAccounts"
                     [typeaheadOptionField]="'name'"
                     (typeaheadOnSelect)="setSelectedProperty($event.item, 'id', workspaceData, 'storageAccountId')"
                     placeholder="Enter Storage Account"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(storageAccount.invalid && storageAccount.touched)">
                Please provide valid Storage Account
              </span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Container Registry</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required
                     name="containerRegistry"
                     ngModel #containerRegistry="ngModel"
                     [(ngModel)]="workspaceData.containerRegistryName"
                     [typeahead]="containerRegistries"
                     [typeaheadOptionField]="'name'"
                     (typeaheadOnSelect)="setSelectedProperty($event.item, 'id', workspaceData, 'containerRegistryId')"
                     placeholder="Enter Container Registry name"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(containerRegistry.invalid && containerRegistry.touched)">
                Please provide valid container registry name
              </span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Workspace Name</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" name="workspace" placeholder="Enter Workspacec name" #workspace="ngModel" class="form-control" [(ngModel)]="workspaceData.workspace"
                     (change)="checkWorkspaceNameAvailability();" required>
              <span class="text-danger" *ngIf="(workspace.invalid && workspace.touched)">
                Please provide valid Workspace
              </span>
              <span class="text-danger" *ngIf="workspaceData.resourceGroupName == ''">
                Please fill resource group name first.
              </span>
              <span class="text-danger" *ngIf="workspaceNameAvailable == false">
                Workspace name is not available.
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 pad-lr">
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Resource Group</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required name="resourceGroup"
                     #resourceGroup="ngModel"
                     [(ngModel)]="workspaceData.resourceGroupName"
                     [typeahead]="resourceGroups"
                     [typeaheadOptionField]="'name'"
                     (typeaheadOnSelect)="setSelectedProperty($event.item, 'id', workspaceData, 'resourceGroupId'); loadAllChildResources($event.item.name);"
                     placeholder="Enter Resource Group Name"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(resourceGroup.invalid && resourceGroup.touched)">
                Please provide valid resource group name
              </span>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Key Vault</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required
                     name="KeyVault"
                     ngModel #KeyVaults="ngModel"
                     [(ngModel)]="workspaceData.keyVaultName"
                     [typeahead]="keyVaults"
                     [typeaheadOptionField]="'name'"
                     (typeaheadOnSelect)="setSelectedProperty($event.item, 'id', workspaceData, 'keyVaultId')"
                     placeholder="Enter Key Vault"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(KeyVaults.invalid && KeyVaults.touched)">
                Please provide valid Key Vault
              </span>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Application Insight</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input type="text" class="form-control" required
                     name="applicationInsight"
                     ngModel #applicationInsight="ngModel"
                     [(ngModel)]="workspaceData.applicationInsightName"
                     [typeahead]="applicationInsights"
                     [typeaheadOptionField]="'name'"
                     (typeaheadOnSelect)="setSelectedProperty($event.item, 'id', workspaceData, 'applicationInsightId')"
                     placeholder="Enter Application Insight name"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off">
              <span class="text-danger" *ngIf="(applicationInsight.invalid && applicationInsight.touched)">
                Please provide valid application insight name
              </span>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Workspace Edition</label>
            </div>
            <div class="col-sm-8">
              <input type="text" name="workspaceEdition" #workspaceEdition="ngModel" class="form-control"
                     [(ngModel)]="workspaceData.workspaceEdition" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-sm-12 btnRow-align text-center">
        <button class="saveBtn2 mr5" [disabled]="!(workspaceFormContainer.valid) || (isCompleted==true)" (click)="addWorkspace()">SAVE</button>
        <button class="saveBtn2" tabindex="0" (click)="onCancelClick()">CANCEL</button>
      </div>
      <div *ngIf="isLoader==true" class="col-sm-12 widgetContainer pl-30p">
        <span class="span-label">{{loaderMessage}}</span>
        <div class="loader"></div>
      </div>
    </div>
  </form>
</div>

